<div id="card-container"></div>

@if (loaderService.depositRedirectInProgress()) {
    <form
        method="POST"
        name="depositpostredirectform"
        id="depositpostredirectform"
        target="TheWindow"
        [action]="depositRedirectService.depRedirectSignal().redirectionUrl">
        @if (depositRedirectService.depRedirectSignal().submitCreq) {
            <input type="hidden" name="creq" [value]="depositRedirectService.depRedirectSignal().creq" />
        }
        @let redirectPostData = depositRedirectService?.depositSubmitResponse?.postData;
        @if (depositRedirectService.depRedirectSignal().submitJwt) {
            <input type="hidden" name="JWT" [value]="redirectPostData.JWT" />
            <input type="hidden" name="MD" [value]="redirectPostData.MD" />
        }
        @if (!(depositRedirectService.depRedirectSignal().submitCreq || depositRedirectService.depRedirectSignal().submitJwt)) {
            <input type="hidden" name="PaReq" [value]="redirectPostData?.PaReq" />
            <input type="hidden" name="TermUrl" [value]="depositRedirectService?.depositSubmitResponse?.redirectionBackUrl" />
            <input type="hidden" name="MD" [value]="redirectPostData?.MD" />
        }
    </form>
}
<iframe src="" style="display: none" name="threeDS2redirect" id="threeDS2redirect"></iframe>
@if (isCvvDialogVisible()) {
    <div class="cvv-dialog dialog-overlay-qd">
        <div class="tooltip-content cvv-dialog-content">
            <p class="my-2 mx-3">{{ 'PARTY.CASHIER.web.deposit.cvv.tooltip' | translate }}</p>
            <span class="card-icon"></span>
            <div class="dialog-action-btn mt-2">
                <button type="button" class="btn btn-primary okgotit" (click)="closetooltip()">
                    {{ 'PARTY.CASHIER.web.common.okgotit' | translate }}
                </button>
            </div>
        </div>
    </div>
}
